import conf from '@/config.js'
import store from '@/store'
import router from '@/router'
import axios from 'axios'

const request = axios.create({
  baseURL: conf.apiUrl
})

request.interceptors.request.use(req => {
  const daUser = localStorage.getItem('daUser')

  if (daUser) {
    const { token } = JSON.parse(daUser)
    req.headers['Authorization'] = token
  }

  return req
})

request.interceptors.response.use(
  response => {
    // Do something with response data
    return response
  },
  error => {
    // Do something with response error
    // You can even test for a response code
    // and try a new request before rejecting the promise

    const { response } = error

    if (response && response.status === 401) {
      if (!store.state.initialized) {
        store.commit('LOGOUT_USER')
        return router.push({
          name: 'Login',
          params: { errorMsg: 'Sessão Expirada!' }
        })
      } else {
        router.app.$toastr.e('Seu token expirado ou inválido faça o login novamente!')
        router.app.$refs.loginModal.show()
      }
    }

    return Promise.reject(error)
  }
)

export { request }

// URL and endpoint constants
const DELETE_URL = {
  TAG: 'tags/delete',
  EIXO: 'eixos/delete',
  USER: 'user/delete',
  META: 'meta/delete',
  DADO: 'dado/delete',
  DADOVALOR: 'dado/valor/delete',
  PLANOGOVERNO: 'planogoverno/delete',
  COMPROMISSOACOES: 'planogoverno/compromisso/acao/delete'
}

const API_URL = conf.apiUrl

export default {
  apiUrlRoot: API_URL,
  apiHeaderAuthorization() {
    const daUser = localStorage.getItem('daUser')

    if (daUser) { 
      const { token } = JSON.parse(daUser)
      return {
        Authorization: token
      }
    }

    return ""
  },
  request(method, url, fnSuccess, fnError, putToken, params, headers) {
    var uri = API_URL + url
    var http = new XMLHttpRequest()
    var me = this
    http.open(method, uri)

    if (headers) {
      me.setHeaders(headers, http)
    }

    if (putToken) {
      var data = localStorage.getItem('daUser')
      if (data) {
        http.setRequestHeader('Authorization', JSON.parse(data).token)
      }
    }

    http.onreadystatechange = function() {
      try {
        if (this.readyState !== 4) return

        const { status } = http
        if ([200, 204].includes(status)) {
          fnSuccess(me.getResponseJson(this))
        } else {
          throw new Error('requisição com erro!')
        }
      } catch (e) {
        me.filterFail(me.getResponseJson(this), fnError)
      }
    }

    if (params) {
      http.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      http.send(me.formatParams(params))
      return
    }

    http.send()
  },
  authenticate(credencial, fnSuccess, fnError) {
    this.post(
      'auth/login',
      credencial,
      response => {
        localStorage.setItem('daUser', JSON.stringify(response))
        // store.commit('LOGIN_USER')
        fnSuccess(response)
      },
      fnError
    )
  },
  get(url, fnSuccess, fnError) {
    this.request('GET', url, fnSuccess, fnError, true)
  },
  post(url, data, fnSuccess, fnError) {
    this.request('POST', url, fnSuccess, fnError, true, data)
  },
  formatParams(obj, prefix) {
    var str = []
    var p
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + '[' + p + ']' : p
        var v = obj[p]
        str.push(
          v !== null && typeof v === 'object'
            ? this.formatParams(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v)
        )
      }
    }
    return str.join('&')
  },
  setHeaders(headers, http) {
    for (var i = 0; i < headers.length; i++) {
      http.setRequestHeader(headers[i].key, headers[i].value)
    }
  },
  filterFail(response, fnFailClient) {
    fnFailClient = typeof fnFailClient === 'function' ? fnFailClient : () => {};
    if (response) {
      if (response.hasOwnProperty('tokenIsExpired')) {
        localStorage.daUser = ''
        router.app.$refs.loginModal.show()
        store.commit('LOGOUT_USER')
        router.push({ name: 'Login', params: { errorMsg: 'Sessão Expirada!' } })
        return
      }
      if (response.hasOwnProperty('tokenInvalid')) {
        localStorage.daUser = ''
        store.commit('LOGOUT_USER')
        router.push({
          name: 'Login',
          params: { errorMsg: 'Usuário ou senha inválidos!' }
        })
        return
      }
    }
    fnFailClient(response)
  },
  delete(model, fnSuccess, fnError) {
    var key = Object.keys(model)[0]
    var value = model[key]
    var data = '{"' + key + '": ' + value + '}'
    this.post(DELETE_URL[model.type], JSON.parse(data), fnSuccess, fnError)
  },
  getResponseJson(http) {
    let response = ''

    if (http.responseText.length > 0) response = JSON.parse(http.response)

    return response
  },
  ws: {
    request(method, url, data, fnSuccess, fnError) {
      var uri = API_URL + url
      var http = new XMLHttpRequest()
      var me = this
      http.open(method, uri)
      http.setRequestHeader('Content-Type', 'application/json')

      http.onreadystatechange = function() {
        if (http.readyState === 4) {
          var resp = JSON.parse(http.response)
          if (http.status === 200) {
            fnSuccess(resp)
          } else {
            me.filterFail(resp, fnError)
          }
        }
      }
      http.send(JSON.stringify(data))
    },
    secretarias(data, fnSuccess, fnError) {
      this.request('GET', 'ExibirPorId', data, fnSuccess, fnError)
    }
  }
}



// WEBPACK FOOTER //
// ./src/request/index.js